<template>
  <div class="robot-accounts">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      <el-breadcrumb-item>机器人专用账号</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-alert title="专用账号无需真实手机号，初始密码统一为 123456。医院科室沿用机器人科普宣教配置；登录机器人后仍需完成带教绑定。" type="info" :closable="false" />
      <div class="toolbar">
        <el-select v-model="scopeId" clearable filterable placeholder="全部医院科室" @change="search">
          <el-option v-for="scope in scopes" :key="scope.id" :value="scope.id" :label="scopeLabel(scope)" />
        </el-select>
        <el-button @click="search">查询</el-button>
        <el-button type="primary" @click="openCreate">批量创建</el-button>
        <el-button :disabled="!rows.length" @click="exportRows(rows)">导出当前页</el-button>
      </div>
      <el-table v-loading="loading" :data="rows" border stripe>
        <el-table-column prop="account" label="登录账号" width="150" />
        <el-table-column prop="name" label="账号名称" />
        <el-table-column prop="hospitalName" label="医院" />
        <el-table-column prop="departmentName" label="科室" />
        <el-table-column label="科室状态" width="100">
          <template slot-scope="scope">{{ scope.row.scopeActive ? '启用' : '停用' }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="190" />
      </el-table>
      <el-pagination :current-page="page" :page-size="20" :total="total" layout="total, prev, pager, next" @current-change="changePage" />
    </el-card>
    <el-card>
      <div class="section-title">机器人异常占用与隔离</div>
      <el-button size="mini" :loading="bindingLoading" @click="loadBindings">刷新状态</el-button>
      <el-table v-loading="bindingLoading" :data="bindings" border stripe style="margin-top: 12px">
        <el-table-column prop="robotName" label="机器人" />
        <el-table-column prop="serialNumber" label="序列号" />
        <el-table-column label="状态">
          <template slot-scope="scope">{{ scope.row.quarantined ? '未确认回桩，已隔离' : (scope.row.busy ? '占用中' : '可用') }}</template>
        </el-table-column>
        <el-table-column label="会话 ID">
          <template slot-scope="scope">{{ scope.row.occupiedSessionId || scope.row.recoverableSessionId || '' }}</template>
        </el-table-column>
        <el-table-column prop="quarantineReason" label="隔离原因" />
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.quarantined" size="mini" type="warning" @click="clearQuarantine(scope.row)">确认位置并解除隔离</el-button>
            <el-button v-else-if="scope.row.occupiedSessionId || scope.row.recoverableSessionId" size="mini" type="danger" @click="releaseBinding(scope.row)">强制释放并隔离</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="批量创建机器人专用账号" :visible.sync="createVisible" :close-on-click-modal="false" :show-close="!submitting" :before-close="beforeClose">
      <el-form label-width="110px">
        <el-form-item label="医院科室">
          <el-select v-model="form.scopeId" filterable :disabled="!!pendingRequest" placeholder="选择已启用的宣教医院科室">
            <el-option v-for="scope in activeScopes" :key="scope.id" :value="scope.id" :label="scopeLabel(scope)" />
          </el-select>
        </el-form-item>
        <el-form-item label="名称前缀">
          <el-input v-model="form.namePrefix" maxlength="30" :disabled="!!pendingRequest" placeholder="如：康复科机器人" />
        </el-form-item>
        <el-form-item label="创建数量">
          <el-input-number v-model="form.count" :min="1" :max="100" :disabled="!!pendingRequest" />
        </el-form-item>
        <el-form-item label="初始密码">123456</el-form-item>
      </el-form>
      <el-alert v-if="pendingRequest" title="请求结果待确认。再次点击会查询或重试同一批次，不重复生成账号。" type="warning" :closable="false" />
      <span slot="footer">
        <el-button :disabled="submitting" @click="createVisible = false">关闭</el-button>
        <el-button type="primary" :loading="submitting" @click="submit">{{ pendingRequest ? '确认本批次结果 / 重试' : '创建账号' }}</el-button>
      </span>
    </el-dialog>
    <el-dialog title="本批次账号清单" :visible.sync="resultVisible" width="80%">
      <p>共 {{ createdRows.length }} 个账号，初始密码：123456。请保存清单后在机器人输入账号和密码登录。</p>
      <el-button type="primary" @click="exportRows(createdRows)">导出本批次</el-button>
      <el-table :data="createdRows" border>
        <el-table-column prop="account" label="登录账号" />
        <el-table-column prop="name" label="账号名称" />
        <el-table-column prop="hospitalName" label="医院" />
        <el-table-column prop="departmentName" label="科室" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
const pendingKey = 'robot-account-pending-batch'
export default {
  data () {
    return {
      scopes: [], scopeId: null, page: 1, total: 0, rows: [], loading: false,
      createVisible: false, resultVisible: false, submitting: false,
      form: { scopeId: null, count: 1, namePrefix: '机器人' },
      pendingRequest: null, createdRows: [], bindings: [], bindingLoading: false
    }
  },
  computed: {
    activeScopes () { return this.scopes.filter(scope => scope.active) }
  },
  created () {
    try {
      this.pendingRequest = JSON.parse(window.sessionStorage.getItem(pendingKey) || 'null')
      if (this.pendingRequest) this.form = { ...this.pendingRequest }
    } catch (error) {
      this.$message.error('待确认批次记录读取失败，请先在账号列表核对已有账号')
    }
    this.loadScopes()
    this.loadList()
    this.loadBindings()
  },
  methods: {
    scopeLabel (scope) { return `${scope.hospitalName} / ${scope.departmentName}${scope.active ? '' : '（停用）'}` },
    async loadScopes () {
      try {
        const scopes = []
        let page = 1
        let total = 0
        do {
          const { data: resp } = await this.$http.get('doctor_hospital_department/manage/list', { params: { page, pageSize: 100 } })
          if (resp.code !== 200) throw new Error(resp.message || '医院科室读取失败')
          const list = resp.data.list || []
          scopes.push(...list)
          total = resp.data.total || 0
          if (!list.length) break
          page++
        } while (scopes.length < total)
        this.scopes = scopes
      } catch (error) { this.$message.error(error.message || '医院科室读取失败') }
    },
    search () { this.page = 1; this.loadList() },
    changePage (page) { this.page = page; this.loadList() },
    async loadBindings () {
      this.bindingLoading = true
      try {
        const { data: resp } = await this.$http.get('cms/robot-teaching/bindings')
        if (resp.code !== 200) throw new Error(resp.message || '机器人状态读取失败')
        this.bindings = resp.data || []
      } catch (error) { this.$message.error(error.message || '机器人状态读取失败') } finally { this.bindingLoading = false }
    },
    releaseBinding (row) {
      this.$prompt('请输入强制释放原因，例如：设备离线、已人工确认不在任务现场', '强制释放并隔离', {
        confirmButtonText: '确认释放', cancelButtonText: '取消', inputValidator: value => value && value.trim() ? true : '必须填写原因'
      }).then(({ value }) => this.$http.post(`cms/robot-teaching/sessions/${row.occupiedSessionId || row.recoverableSessionId}/members/${row.id}/force-release`, { reason: value.trim() }))
        .then(({ data: resp }) => {
          if (resp.code !== 200) throw new Error(resp.message || '释放失败')
          this.$message.success('已释放占用并隔离机器人')
          this.loadBindings()
        }).catch(error => { if (error !== 'cancel') this.$message.error(error.message || '释放失败') })
    },
    clearQuarantine (row) {
      this.$confirm('请确认机器人已回到安全位置，且可以重新接受带教任务。', '解除隔离', {
        confirmButtonText: '确认解除', cancelButtonText: '取消', type: 'warning'
      }).then(() => this.$http.post(`cms/robot-teaching/bindings/${row.id}/clear-quarantine`))
        .then(({ data: resp }) => {
          if (resp.code !== 200) throw new Error(resp.message || '解除失败')
          this.$message.success('机器人已解除隔离')
          this.loadBindings()
        }).catch(error => { if (error !== 'cancel') this.$message.error(error.message || '解除失败') })
    },
    async loadList () {
      this.loading = true
      try {
        const { data: resp } = await this.$http.get('cms/robot-accounts', { params: { scopeId: this.scopeId || undefined, page: this.page, size: 20 } })
        if (resp.code !== 200) throw new Error(resp.message || '账号读取失败')
        this.rows = resp.data.rows || []
        this.total = resp.data.total || 0
      } catch (error) { this.$message.error(error.message || '账号读取失败') } finally { this.loading = false }
    },
    openCreate () {
      if (!this.pendingRequest) this.form = { scopeId: this.scopeId, count: 1, namePrefix: '机器人' }
      this.createVisible = true
    },
    beforeClose (done) { if (!this.submitting) done() },
    requestId () {
      const bytes = new Uint8Array(16)
      window.crypto.getRandomValues(bytes)
      bytes[6] = (bytes[6] & 15) | 64
      bytes[8] = (bytes[8] & 63) | 128
      const hex = Array.from(bytes, value => value.toString(16).padStart(2, '0')).join('')
      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
    },
    async submit () {
      if (this.submitting) return
      const namePrefix = this.form.namePrefix.trim()
      if (!this.form.scopeId || !namePrefix || !Number.isInteger(this.form.count) || this.form.count < 1 || this.form.count > 100) {
        this.$message.warning('请选择医院科室、填写名称前缀，数量为 1–100')
        return
      }
      this.submitting = true
      try {
        if (!this.pendingRequest) {
          const request = { scopeId: this.form.scopeId, count: this.form.count, namePrefix, requestId: this.requestId() }
          // 请求发送前保存，页面刷新或响应丢失仍可恢复原批次。
          window.sessionStorage.setItem(pendingKey, JSON.stringify(request))
          this.pendingRequest = request
        }
        const { data: resp } = await this.$http.post('cms/robot-accounts', this.pendingRequest)
        if (resp.code !== 200) {
          if (resp.data && resp.data.requestRejected) {
            window.sessionStorage.removeItem(pendingKey)
            this.pendingRequest = null
          }
          this.$message.error(resp.message || '创建失败，请核对后重试本批次')
          return
        }
        this.createdRows = resp.data.accounts || []
        this.resultVisible = true
        this.createVisible = false
        window.sessionStorage.removeItem(pendingKey)
        this.pendingRequest = null
        this.$message.success(`本批次共 ${this.createdRows.length} 个账号`)
        this.search()
      } catch (error) {
        this.$message.error('未确认创建结果，请保留当前批次并点击重试，避免另开批次重复创建')
      } finally { this.submitting = false }
    },
    exportRows (rows) {
      const escape = value => {
        let text = String(value == null ? '' : value)
        if (/^[=+\-@\t\r]/.test(text)) text = "'" + text
        return '"' + text.replace(/"/g, '""') + '"'
      }
      const data = [['登录账号', '账号名称', '医院', '科室', '初始密码'],
        ...rows.map(row => [row.account, row.name, row.hospitalName, row.departmentName, '123456'])]
      const blob = new Blob(['\uFEFF' + data.map(row => row.map(escape).join(',')).join('\r\n')], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = '机器人账号清单.csv'
      link.click()
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style scoped>
.robot-accounts { padding: 20px; }
.el-card { margin-top: 20px; }
.toolbar { display: flex; gap: 12px; margin: 20px 0; }
.el-select { min-width: 320px; }
.el-pagination { margin-top: 16px; text-align: right; }
</style>
